// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.labelStyle{
    font-family: ProximaNova-Regular, TeXGyreHerosRegular, Helvetica, Arial, sans-serif; 
    font-size: 14px; 
    padding-right: 5px;
}

.inputDate{
    width:140px; 
    border-radius:5px;
    border: 1px solid teal; 
    height: 30px; color: black;
    font-size: 14px;
}

.table-container {
    /* max-height: calc(100vh - 365px); */
    overflow: auto;
}

table {
    overflow: auto;
    border-collapse: collapse;
    width: 100%;
}

.table-spec {
    width: 100%;
    max-width: 100%;
    empty-cells: show;
    border: 0;
}

td, th {
    border: 1px solid #dddddd;
    text-align: left;
    font-weight: normal;
}

td {
    padding: 6px 10px;
}

th {
    border-top: none;
    position: sticky;
    top: 0;
    padding: 10px;
    background: #212529;
    color: #ffffff;
    font-size: 14px;
    z-index: 1;
}

tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

td .txtarea {
    width: 100% !important;
}

td textarea:hover {
    border: 1px solid gray !important;
}
/* 
.first td:nth-child(1) {
    color: teal;
} */

.active {
    background-color: teal !important;
    color: white;
}

.active td:nth-child(1) {
    color: white;
}

.child {
    background-color: white !important;
    border-left: 4px solid teal;
    border-right: 3px solid teal;
    border-bottom: 2px solid teal;
}

.divBorder{
    background-color:white;
    border: 1px solid #ccc;
}

.divGreyBorder{
    background-color:#f2f2f2;
    border: 1px solid #ccc;
}

.divAlign{
    font-size:14px; 
    height: 30px; 
    line-height: 30px; 
    text-align: center;
}

.headerAlign{
    font-size:14px; 
    background: black; 
    color:white; 
    text-align: center; 
    height: 30px; 
    line-height: 30px;
}

.tableColumnFilter {
    background-color: white;    
    border-radius: 4px;
    width: 100%;
    height: 31px;    
    color:black;
    padding-left: 15px;
    border: 2px hidden black;
}

.app-toolbar{
    border:1px solid grey;
    position: sticky;
    position: -webkit-sticky; 
    top: 0;
    z-index: 1000;
}

.dropdown-item:hover{
    background-color: teal;
}

.dropdown-item:hover{
    padding: 0.10rem 1.5rem;
}

.mat-option.mat-active {
    background-color: white;
    color: black;
}
.tealText{
    color:teal !important;
}

.addEquipInput{
    width: 235px;
    border:  1px solid rgb(211, 211, 211);
    border-radius: 5px;
}

:host ::ng-deep .mat-datepicker-toggle .mat-mdc-icon-button svg {
    vertical-align: middle;
    color: teal;
  }
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/View/core/reports/ops-count-report/ops-count-report.component.css"],"names":[],"mappings":"AAAA;IACI,mFAAmF;IACnF,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,YAAY,EAAE,YAAY;IAC1B,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;AACA;;;GAGG;;AAEH;IACI,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;IACxB,MAAM;IACN,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,WAAW;EACb;AACF,ooLAAooL","sourcesContent":[".labelStyle{\r\n    font-family: ProximaNova-Regular, TeXGyreHerosRegular, Helvetica, Arial, sans-serif; \r\n    font-size: 14px; \r\n    padding-right: 5px;\r\n}\r\n\r\n.inputDate{\r\n    width:140px; \r\n    border-radius:5px;\r\n    border: 1px solid teal; \r\n    height: 30px; color: black;\r\n    font-size: 14px;\r\n}\r\n\r\n.table-container {\r\n    /* max-height: calc(100vh - 365px); */\r\n    overflow: auto;\r\n}\r\n\r\ntable {\r\n    overflow: auto;\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n}\r\n\r\n.table-spec {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    empty-cells: show;\r\n    border: 0;\r\n}\r\n\r\ntd, th {\r\n    border: 1px solid #dddddd;\r\n    text-align: left;\r\n    font-weight: normal;\r\n}\r\n\r\ntd {\r\n    padding: 6px 10px;\r\n}\r\n\r\nth {\r\n    border-top: none;\r\n    position: sticky;\r\n    top: 0;\r\n    padding: 10px;\r\n    background: #212529;\r\n    color: #ffffff;\r\n    font-size: 14px;\r\n    z-index: 1;\r\n}\r\n\r\ntbody tr:nth-child(even) {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\ntd .txtarea {\r\n    width: 100% !important;\r\n}\r\n\r\ntd textarea:hover {\r\n    border: 1px solid gray !important;\r\n}\r\n/* \r\n.first td:nth-child(1) {\r\n    color: teal;\r\n} */\r\n\r\n.active {\r\n    background-color: teal !important;\r\n    color: white;\r\n}\r\n\r\n.active td:nth-child(1) {\r\n    color: white;\r\n}\r\n\r\n.child {\r\n    background-color: white !important;\r\n    border-left: 4px solid teal;\r\n    border-right: 3px solid teal;\r\n    border-bottom: 2px solid teal;\r\n}\r\n\r\n.divBorder{\r\n    background-color:white;\r\n    border: 1px solid #ccc;\r\n}\r\n\r\n.divGreyBorder{\r\n    background-color:#f2f2f2;\r\n    border: 1px solid #ccc;\r\n}\r\n\r\n.divAlign{\r\n    font-size:14px; \r\n    height: 30px; \r\n    line-height: 30px; \r\n    text-align: center;\r\n}\r\n\r\n.headerAlign{\r\n    font-size:14px; \r\n    background: black; \r\n    color:white; \r\n    text-align: center; \r\n    height: 30px; \r\n    line-height: 30px;\r\n}\r\n\r\n.tableColumnFilter {\r\n    background-color: white;    \r\n    border-radius: 4px;\r\n    width: 100%;\r\n    height: 31px;    \r\n    color:black;\r\n    padding-left: 15px;\r\n    border: 2px hidden black;\r\n}\r\n\r\n.app-toolbar{\r\n    border:1px solid grey;\r\n    position: sticky;\r\n    position: -webkit-sticky; \r\n    top: 0;\r\n    z-index: 1000;\r\n}\r\n\r\n.dropdown-item:hover{\r\n    background-color: teal;\r\n}\r\n\r\n.dropdown-item:hover{\r\n    padding: 0.10rem 1.5rem;\r\n}\r\n\r\n.mat-option.mat-active {\r\n    background-color: white;\r\n    color: black;\r\n}\r\n.tealText{\r\n    color:teal !important;\r\n}\r\n\r\n.addEquipInput{\r\n    width: 235px;\r\n    border:  1px solid rgb(211, 211, 211);\r\n    border-radius: 5px;\r\n}\r\n\r\n:host ::ng-deep .mat-datepicker-toggle .mat-mdc-icon-button svg {\r\n    vertical-align: middle;\r\n    color: teal;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
